if (!customElements.get('th-sticky-atc')) {
  class ThStickyAtc extends HTMLElement {
    constructor() {
      super();

      this.RECHARGE_SELECT_SELECTOR = "[data-th-recharge-select]";
      this.RECHARGE_RADIO_INPUT_SELECTOR = ".rc-radio__input";
    }

    connectedCallback() {
      this.RECHARGE_SELECT = this.querySelector(this.RECHARGE_SELECT_SELECTOR);
      if(!this.RECHARGE_SELECT){return}
      this.attachListeners();
    }

    attachListeners() {
      window.addEventListener("scroll", (event) => {
        this.toggleStickyATC();
      });
      window.addEventListener("th:recharge-ready", (event) => {
        this.handleRechargeChange(event);
      });
      window.addEventListener("th:recharge-change", (event) => {
        this.handleRechargeChange(event);
      });
      this.RECHARGE_SELECT.addEventListener("change", () => {
        this.handleSelectChange();
      });
    }

    toggleStickyATC() {
      const form = document.getElementById(`product-form-${this.dataset.section}`)
      const footer = document.getElementById('footer');
      if (!this.elementIsVisibleInViewport(form) && !this.elementIsVisibleInViewport(footer, true)) {
        this.classList.add('sticky--visible');
        this.moveAccessiblyIcon(true);
        this.moveMessengerIcon(true);
      } else {
        this.classList.remove('sticky--visible');
        this.moveAccessiblyIcon(false);
        this.moveMessengerIcon(false);
      }
    }

    elementIsVisibleInViewport(el, partiallyVisible = false) {
      const { top } = el.getBoundingClientRect();
      const { innerHeight } = window;
      return partiallyVisible ? top <= (innerHeight / 2) : top >= 76;
    };

    handleRechargeChange(event) {
      if (!event.detail) {return}
      if (event.detail.value === 'subscription') {
        this.RECHARGE_SELECT.value = 'Monthly';
      } else if (event.detail.value === 'onetime') {
        this.RECHARGE_SELECT.value = 'One-Time';
      }
    }

    handleSelectChange() {
      if (this.RECHARGE_SELECT.value === 'Monthly') {
        document.querySelectorAll(this.RECHARGE_RADIO_INPUT_SELECTOR).forEach((input) => {
          if (input.value === 'subscription') {
            input.parentElement.click();
          }
        });
      } else if (this.RECHARGE_SELECT.value === 'One-Time') {
        document.querySelectorAll(this.RECHARGE_RADIO_INPUT_SELECTOR).forEach((input) => {
          if (input.value === 'onetime') {
            input.parentElement.click();
          }
        });
      }
    }

    moveAccessiblyIcon(visible) {
      const icon = document.getElementById('accessiblyOtmButton');
      if (icon && visible) {
        icon.classList.add('th-sticky-atc-open');
      } else if (icon && !visible) {
        icon.classList.remove('th-sticky-atc-open');
      }
    }
    moveMessengerIcon(visible) {
      const icon = document.querySelector('#gorgias-chat-container iframe')
      if (icon && visible) {
        icon.classList.add('th-sticky-atc-open__messenger');
      } else if (icon && !visible) {
        icon.classList.remove('th-sticky-atc-open__messenger');
      }
    }


  }

  customElements.define('th-sticky-atc', ThStickyAtc);
}